import { render, staticRenderFns } from "./MobileSite.vue?vue&type=template&id=71dae6ba&scoped=true&"
import script from "./MobileSite.vue?vue&type=script&lang=js&"
export * from "./MobileSite.vue?vue&type=script&lang=js&"
import style0 from "./MobileSite.vue?vue&type=style&index=0&id=71dae6ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dae6ba",
  null
  
)

export default component.exports